import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../utils/config';
import './ManagePage.css';

function ManagePage() {
  const [appointmentId, setAppointmentId] = useState('');
  const [phone, setPhone] = useState('');
  const [appointment, setAppointment] = useState(null);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSearch = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setAppointment(null);

    try {
      const response = await fetch(`${API_BASE_URL}/api/appointments/${appointmentId}?phone=${phone}`);
      const data = await response.json();

      if (data.success) {
        setAppointment(data.appointment);
      } else {
        setError(data.error || '查询预约失败');
      }
    } catch (err) {
      setError('查询过程中出错，请稍后重试');
    }
  };

  const handleCancel = async () => {
    if (!appointment) return;

    try {
      const response = await fetch(`${API_BASE_URL}/api/appointments/${appointment.id}?phone=${phone}`, {
        method: 'DELETE',
      });

      const data = await response.json();

      if (data.success) {
        setMessage('预约已成功取消');
        setAppointment(null);
      } else {
        setError(data.error || '取消预约失败');
      }
    } catch (err) {
      setError('取消过程中出错，请稍后重试');
    }
  };

  return (
    <div className="manage-page">
      <div className="header">
        <h2>查询/取消预约</h2>
        <Link to="/" className="home-link">返回首页</Link>
      </div>
      <div className="search-container">
        <form onSubmit={handleSearch}>
          <div className="form-group">
            <label>预约编号：</label>
            <input
              type="text"
              value={appointmentId}
              onChange={(e) => setAppointmentId(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>电话号码：</label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
          </div>
          <button type="submit">查询预约</button>
        </form>

        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}

        {appointment && (
          <div className="appointment-details">
            <h3>预约详情</h3>
            <p><strong>姓名：</strong>{appointment.name}</p>
            <p><strong>电话：</strong>{appointment.phone}</p>
            <p><strong>日期：</strong>{appointment.date}</p>
            <p><strong>时间：</strong>{appointment.startTime} - {appointment.endTime}</p>
            {appointment.currentSituation && (
              <p><strong>当前情况：</strong>{appointment.currentSituation}</p>
            )}
            {appointment.problemToSolve && (
              <p><strong>需要解决的问题：</strong>{appointment.problemToSolve}</p>
            )}
            <button onClick={handleCancel} className="cancel-btn">取消预约</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ManagePage; 